import { useTranslation } from 'react-i18next'

import { Divider, Text } from '@reveni-io/reveni-ui'

import LocationsSelector from '@/configuration/components/LocationsSelector/LocationsSelector'

import CarrierInfo from '../CarrierInfo/CarrierInfo'
import { getLocationPayload, getSelectedLocationId } from '../helpers'
import * as Styles from './styles'

const CustomerDeliversMethod = ({ config, onChange, errors }) => {
  const { t } = useTranslation()

  const handleChangeLocation = location => onChange(getLocationPayload(location))

  return (
    <>
      {config?.carrier?.is_connected && (
        <>
          <CarrierInfo name={config?.carrier?.name} serviceName={config?.carrier?.service_name} />
          <Divider />
        </>
      )}
      <Styles.MainContainer>
        <Text type="titleS">{t('Dirección de envío')}</Text>
        <Text type="bodyMRegular">
          {t(
            'Selecciona la ubicación a la que el cliente debe devolver los productos. Sus detalles se mostrarán en los emails a continuación de las instrucciones de devolución.'
          )}
        </Text>
        <LocationsSelector value={getSelectedLocationId(config)} onChange={handleChangeLocation} errors={errors} />
      </Styles.MainContainer>
    </>
  )
}

export default CustomerDeliversMethod
